/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';

export const columns = (): [] => {
  const context = React.useContext(EventDetailContainerContext);
  const time_zone_id = _.get(context, 'eventDetail.time_zone_id', '');

  return [
    {
      selector: 'ticket.name',
      name: 'Ticket Type',
      sortable: true,
      cell: (row: any): any => {
        return row.ticket.name || '';
      }
    },
    {
      selector: 'last_name',
      name: 'Attendee',
      sortable: true,
      cell: (row: any): any => {
        if (!row.first_name && !row.last_name) {
          return '';
        }
        return `${row.first_name || ''} ${row.last_name || ''}`;
      }
    },
    {
      selector: 'check_code',
      name: 'Check Code',
      sortable: true,
      cell: (row: any): any => {
        return row.check_code || '';
      }
    },
    {
      selector: 'checkin_time_utc',
      name: 'Checkin Time',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        if (!row.checkin_time_utc) {
          return '';
        }
        return convertToLocalTime(_.get(row, 'checkin_time_utc', ''), time_zone_id, 'MM/DD/YY h:mm a z');
      }
    }
  ];
};